import { apiClient } from '../client/axiosClient';
import { GroupDto, GroupResponse, GroupsResponse, GroupQueryParams } from '../types/dtos/group';

/**
 * Group Service handles CRUD operations for groups.
 *
 * URL Pattern: /api/v1/groups
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * @deprecated organizationId parameters are deprecated and no longer used.
 */

const BASE_PATH = '/api/v1/groups';

export const groupService = {
  /**
   * Get all groups for the current organization (from X-Organization-Id header).
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   */
  getGroups: async (_organizationId: string, params?: GroupQueryParams): Promise<GroupsResponse> => {
    return apiClient.get(BASE_PATH, { params });
  },

  /**
   * Get a group by ID.
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param id - Group UUID
   */
  getGroupById: async (_organizationId: string, id: string): Promise<GroupResponse> => {
    return apiClient.get(`${BASE_PATH}/${id}`);
  },

  /**
   * Create a new group.
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param group - Group data
   */
  createGroup: async (_organizationId: string, group: GroupDto): Promise<GroupResponse> => {
    return apiClient.post(BASE_PATH, group);
  },

  /**
   * Update a group.
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param id - Group UUID
   * @param group - Updated group data
   */
  updateGroup: async (_organizationId: string, id: string, group: GroupDto): Promise<GroupResponse> => {
    return apiClient.put(`${BASE_PATH}/${id}`, group);
  },

  /**
   * Delete a group.
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param id - Group UUID
   */
  deleteGroup: async (_organizationId: string, id: string): Promise<GroupResponse> => {
    return apiClient.delete(`${BASE_PATH}/${id}`);
  }
}; 